import React from 'react'

import ChartReviewNote from './ChartReviewNote'
import ChartReviewNoteForm from './ChartReviewNoteForm'

const ChartReviewNotes = (props) => {
  const {
    notes,
    section,
  } = props

  return (
    <div>
      {notes && notes.length ? notes.sort((a, b) => new Date(a.created_date) - new Date(b.created_date)).map(note => (
        <React.Fragment key={note.url}>
          <ChartReviewNote
            note={note}
            adverseEventName={props.adverseEventName || null}
            editChartReviewNote={props.editChartReviewNote}
            readOnly={props.readOnly}
            saveButtonText={props.saveButtonText}
            formLabel={props.formLabel}
            formPlaceholder={props.formPlaceholder}
          />
          <br />
        </React.Fragment>
      ))
        :
        <p>
          {props.noNotesMessage || "No notes for this section"}
        </p>
      }

      {props.readOnly === true ?
        null
        :
        <>
          <hr />

          <h6>
            {props.formLabel || "Add a new note"}
          </h6>

          <ChartReviewNoteForm
            method="POST"
            section={section}
            handleSaveComplete={props.addChartReviewNote}
            adverseEventUrl={props.adverseEventUrl || null}
            adverseEventName={props.adverseEventName || null}
            readOnly={props.readOnly}
            saveButtonText={props.saveButtonText}
            formLabel={props.formLabel}
            formPlaceholder={props.formPlaceholder}
          />
        </>
      }

    </div>
  )
}

export default ChartReviewNotes
